import { connect } from 'react-redux'
import UsageCard from '../../components/Settings/UsageCard'

const mapStateToProps = ({ auth }) => {
  const {user:{quota, has_billing_info, role}} = auth
  return {quota, has_billing_info, role}
}

export default connect(mapStateToProps)(UsageCard)
